import React from "react";
import "./MedicalTourism3.css";

const stepsRow1 = [
  { step: 1, label: "Contact us" },
  { step: 2, label: "Medical Data & Reports" },
  { step: 3, label: "Medical Data Review" },
  { step: 4, label: "Hospital Consultation" },
  { step: 5, label: "Decision Making" },
  { step: 6, label: "Your Itinerary" },
  { step: 7, label: "Pre-Travel Information" },
  { step: 8, label: "Arrive at the destination" },
  { step: 9, label: "Consultation with medical team" },
  { step: 10, label: "Treatment" },
  { step: 11, label: "Rejuvenation/Travel" },
  { step: 12, label: "Post-operative care" },
  { step: 13, label: "Return home" },
];

const stepsRow2 = [
  { step: 8, label: "Arrive at the destination" },
  { step: 9, label: "Consultation with medical team" },
  { step: 10, label: "Treatment" },
  { step: 11, label: "Rejuvenation/Travel" },
  { step: 12, label: "Post-operative care" },
  { step: 13, label: "Return home" },
];

const MedicalTourism3 = () => {
  const renderRow = (steps, rowClass) => (
    <div className={`hiw-row ${rowClass}`}>
      {steps.map((item) => (
        <div className={` ${item.step == 7 ? "no-after hiw-item" : "hiw-item"}`} key={item.step}>
          <span className="hiw-badge">STEP {item.step}</span>
          <p className="hiw-label text">{item.label}</p>
        </div>
      ))}
    </div>
  );

  return (
    <section className="hiw-section standard-padding">
      <h1 className="heading hiw-heading">How It Works</h1>
      <div className="hiw-wrapper">
        {renderRow(stepsRow1, "hiw-row-1")}
        {/* {renderRow(stepsRow2, "hiw-row-2")} */}
      </div>
    </section>
  );
};

export default MedicalTourism3;